<template>
  <div class="find-my-size">
    <h4>{{ $t('simple.chooseSize') }}</h4>
    <h5 v-if="title">
      {{ title }}
    </h5>
    <div class="size-chart-container">
      <div ref="chart" class="size-chart">
        <div
          v-for="(size, i) in sizes"
          :key="i"
          class="size-row"
        >
          <div class="size-label">
            {{ size.label }}
          </div>
          <div
            class="size-bar"
            :style="barStyle(i)"
          >
            {{ size.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend(
  {
    name: 'BikesPhoto',
    props: {
      data: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        containerWidth: 0,
        maxWidth: 930
      };
    },
    computed: {
      sizeSpan () {
        return this.$mq.up('md') ? 6 : 1;
      },
      trimmedData () {
        const trimmed = this.data.map(row => row.filter(cell => cell.trim() !== ''));

        // if has a title
        if (trimmed[0].length === 1) {
          return trimmed.slice(1);
        }

        return trimmed;
      },
      title () {
        const firstTrimmed = this.data[0].filter(cell => cell.trim() !== '');
        return firstTrimmed.length === 1 ? firstTrimmed[0] : null;
      },
      columnCount (nbrOfSizes) {
        return nbrOfSizes * this.sizeSpan + this.labelSpan;
      },
      sizes () {
        const trimmed = this.trimmedData;
        return trimmed.map((row) => ({
          label: row[0],
          text: row[1]
        }));
      },
      sizeChartStyle () {
        return {
          'grid-template-columns': `repeat(${this.columnCount}, 1fr)`
        };
      }
    },
    mounted () {
      window.addEventListener('resize', this.updateWidth);
      this.$nextTick(() => this.updateWidth());
    },
    beforeDestroy () {
      window.removeEventListener('resize', this.updateWidth);
    },
    methods: {
      updateWidth () {
        this.containerWidth = this.$refs.chart.offsetWidth;
      },
      // barStyle(i) {
      //   const barCount = this.sizes.length;

      //   if (barCount < 2) {
      //     return {
      //       left: '0px',
      //       width: '100%',
      //     }
      //   }

      //   const container = Math.min(this.containerWidth, this.maxWidth) || 1;
      //   const width = container / barCount;

      //   const left = Math.max(0, i * width);

      //   return {
      //     left: `${left}px`,
      //     width: `${width}px`
      //   }
      // },
      barStyle(i) {
        const total = this.sizes.length;
        const W = (this.maxWidth / total) + (total * 10 * (total - 1) / total);
        const C = Math.min(this.containerWidth, this.maxWidth) || 1;

        if (total < 2) {
          return { left: '0px', width: W + 'px' };
        }

        // total available distance for start positions
        // last bar should end at container end
        const step = (C - W) / (total - 1);
        const left = Math.max(0, i * step);

        return {
          left: left + 'px',
          width: W + 'px',
          maxWidth: '100%'
        };
      }
    }
  });
</script>

<style lang="scss">
@import './assets/scss/style-simple.scss';
</style>
